import { $ } from './utils';

const body = document.body;

body.addEventListener('direct-uploads:start', () => {
  body.style.overflow = 'hidden';
  body.insertAdjacentHTML(
    'beforeend',
    `<div id="uploading"><div id="uploading-body"><div id="uploading-text">アップロード中... <i class="fas fa-upload fa-xl fa-bounce"></i></div><div id="uploading-filename">&nbsp;</div><div id="uploading-progress"><div id="uploading-progressbar"></div></div></div></div>`,
  );
});
body.addEventListener('direct-uploads:end', () => {
  $('uploading')?.remove();
  body.style.overflow = '';
});
body.addEventListener('direct-upload:start', (ev) => {
  $('uploading-filename').textContent = ev.detail.file.name;
});
body.addEventListener('direct-upload:end', () => {
  $('uploading-filename').textContent = '\u00A0';
});
body.addEventListener('direct-upload:progress', (ev) => {
  $('uploading-progressbar').style.width = `${ev.detail.progress}%`;
});
